"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeInputStateGroup = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const mobx_2 = require("../../state/mobx");
const input_state_1 = require("./input.state");
const INPUT_GROUP_TYPE = 'inputstategroup';
class IkeInputStateGroup extends mobx_2.MobxState {
    constructor() {
        super(...arguments);
        this._type = INPUT_GROUP_TYPE;
        this.id = core_shared_1.IkeId.generate();
        this.states = mobx_1.observable.map();
        this.isLabelShown = true;
        this.isAutoFocused = false;
    }
    static isInputStateGroup(input) {
        return input._type === INPUT_GROUP_TYPE;
    }
    child(label, id, type = input_state_1.InputStateTypes.TEXT, initialValue) {
        const state = new input_state_1.InputState(label, id, type);
        this.add(state);
        if (initialValue != null) {
            state.setValue(initialValue);
        }
        return state;
    }
    add(input) {
        if (this.states.has(input.id)) {
            throw new Error('Duplicate state added: ' + input.id);
        }
        this.states.set(input.id, input);
        if (!this.isLabelShown) {
            input.isLabelShown = this.isLabelShown;
        }
    }
    get(id) {
        return this.states.get(id);
    }
    remove(input) {
        this.states.delete(input.id);
    }
    reset() {
        this.states.forEach(state => state.reset());
    }
    get isValid() {
        let isValid = true;
        this.states.forEach(state => {
            if (!state.isValid) {
                isValid = false;
            }
        });
        return isValid;
    }
    get canSubmit() {
        if (!this.isValid) {
            return false;
        }
        let isValid = true;
        this.states.forEach(state => {
            if (IkeInputStateGroup.isInputStateGroup(state)) {
                if (!state.canSubmit) {
                    isValid = false;
                }
            }
            else {
                if (state.isRequired && !state.isFilled) {
                    isValid = false;
                }
            }
        });
        return isValid;
    }
    get isFilled() {
        let isFilled = true;
        this.states.forEach(state => {
            if (!state.isFilled) {
                isFilled = false;
            }
        });
        return isFilled;
    }
    get isRequired() {
        let required = false;
        this.states.forEach(state => {
            if (state.isRequired === true) {
                required = true;
            }
        });
        return required;
    }
    setDisabled(disabled) {
        this.states.forEach(state => state.setDisabled(disabled));
    }
    clearStates() {
        this.states.forEach(state => state.destroy());
        this.states.clear();
    }
    destroy() {
        super.destroy();
        this.clearStates();
    }
    setAutoFocus(isAutoFocused) {
        // Not applicable
    }
}
exports.IkeInputStateGroup = IkeInputStateGroup;
tslib_1.__decorate([
    mobx_1.action
], IkeInputStateGroup.prototype, "child", null);
tslib_1.__decorate([
    mobx_1.action
], IkeInputStateGroup.prototype, "add", null);
tslib_1.__decorate([
    mobx_1.action
], IkeInputStateGroup.prototype, "remove", null);
tslib_1.__decorate([
    mobx_1.action
], IkeInputStateGroup.prototype, "reset", null);
tslib_1.__decorate([
    mobx_1.computed
], IkeInputStateGroup.prototype, "isValid", null);
tslib_1.__decorate([
    mobx_1.computed
], IkeInputStateGroup.prototype, "canSubmit", null);
tslib_1.__decorate([
    mobx_1.computed
], IkeInputStateGroup.prototype, "isFilled", null);
tslib_1.__decorate([
    mobx_1.computed
], IkeInputStateGroup.prototype, "isRequired", null);
tslib_1.__decorate([
    mobx_1.action
], IkeInputStateGroup.prototype, "setDisabled", null);
tslib_1.__decorate([
    mobx_1.action
], IkeInputStateGroup.prototype, "clearStates", null);
tslib_1.__decorate([
    mobx_1.action
], IkeInputStateGroup.prototype, "destroy", null);
//# sourceMappingURL=input.state.group.js.map